<template>
  <div class="workwithus">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div
      class="container mobile-hide"
      style="
    height: 150px;
    background: url(./img/careforsociety_bottom.png)center center /cover;
    transform: scaleX(-1);"
    ></div>
    <div
      class="container mobile-padding"
      style="text-align:left;margin-top:16px;margin-bottom:16px;"
    >
      <div class="columns">
        <div class="column" style="padding-bottom:0; font-size:48px;">
          <span class="title-size">{{$t('body.contact_work_title')}}</span>
          <div class="subtitlebodyblue" style="margin-bottom:30px;">{{$t('body.contact_work_p1')}}</div>
          <div class="subtitlebodyblue">{{$t('body.contact_work_p2')}}</div>
        </div>
      </div>
            <div
        v-if="this.$i18n.locale == 'cn'"
        class="container middle-separator line-bottom-right-140 mobile-hide">
        CONTACT
      </div>
      <div
        v-if="this.$i18n.locale == 'en'"
        class="container middle-separator line-bottom-right mobile-hide">
        <img
          style="position: relative; top: 6px;" src="img/chinese_contact.jpg" alt width="60" />
      </div>

      <div class="container">
        <div class="bodygrey" style="margin:24px 0;">{{$t('body.business_allfield')}}</div>
        <div class="columns" style="margin-top:16px;">
          <div class="column mobile-column-padding-right mobile-column-padding-bottom">
            <div class="form-group">
              <label>{{$t('body.business_fullname')}}</label>
              <input type="text" class="form-control" name="fullname" v-model="fullname" required />
            </div>
            <div class="form-group">
              <label>{{$t('body.business_contact')}}</label>
              <input
                type="text"
                class="form-control"
                name="contactNumber"
                v-model="contactnumber"
                required
              />
            </div>
            <div class="form-group">
              <label>{{$t('body.workwithus_attachment')}}</label>
              <input
                type="file"
                class="form-control"
                id="attachment"
                accept=".doc, .docx, .txt, .pdf"
              />
            </div>
          </div>
          <div class="column">
            <!-- <div class="form-group">
              <label>Company Name *</label>
              <input type="text" class="form-control" name="company" required />
            </div>-->
            <div class="form-group">
              <label>{{$t('body.business_email')}}</label>
              <input type="email" class="form-control" name="email" v-model="email" required />
            </div>
            <div class="form-group" style="height:initial; padding-bottom:16px;">
              <label>Message *</label>
              <textarea
                name="message"
                class="form-control"
                style="height:110px;"
                v-model="message"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column" style="padding-right:16px;">
            <div>
              <img v-if="randomcode == 1045" src="img/1045.jpg" />
              <img v-if="randomcode == 2637" src="img/2637.jpg" />
              <img v-if="randomcode == 3687" src="img/3687.jpg" />
              <img v-if="randomcode == 5639" src="img/5639.jpg" />
              <br />
              <label>{{$t('body.business_imagecode')}}</label>
              <input type="num" class="form-control" name="captcha" v-model="inputcode" required />
              <div class="text-center" style="margin-top:16px;">
                <div class="btn btn-primary" style="width:60px; text-align:center;" @click="submit">{{$t('body.business_send')}}</div>
                <!-- <input -->
                <!--   type="submit" -->
                <!--   name="submit" -->
                <!--   class="btn btn&#45;primary" -->
                <!--   value="Submit" -->
                <!--   @click="submit" -->
                <!-- /> -->
              </div>
            </div>
          </div>
          <div class="column"></div>
        </div>
        <div>
          <div class="pro-msg" style="padding:8px;">Processing...</div>
          <div class="error-msg" style="color:red;padding:8px;">
            Error! Please make sure to fill in
            <strong style="color:red;">all field</strong> and make sure the
            <strong style="color:red;">IMAGE CODE</strong> is correct.
          </div>
          <div class="success-msg" style="padding:8px;">Email sent.</div>
          <div
            class="fail-msg"
            style="padding:8px;color:red;"
          >Opps! Something happened to email server. Please try again later.</div>
        </div>
      </div>
    </div>
    <div style="position:relative;top:50px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "workwithus",
  data() {
    return {
      fullname: "",
      contactnumber: "",
      email: "",
      message: "",
      randomcode: "",
      inputcode: ""
    };
  },
  beforeMount() {
    let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
    let codes = [1045, 2637, 3687, 5639];

    self.randomcode = codes[Math.floor(Math.random() * codes.length)];
    console.log(self.randomcode);
  },
  methods: {
    submit() {
      let self = this;
      console.log(self.fullname);
      console.log(self.contactnumber);
      console.log(self.email);
      console.log(self.message);
      console.log(self.inputcode);
      let pass = true;
      if (self.fullname == "") {
        pass = false;
      }
      if (self.contactnumber == "") {
        pass = false;
      }
      if (self.email == "") {
        pass = false;
      }
      if (self.message == "") {
        pass = false;
      }
      if (self.inputcode == self.randomcode && pass == true) {
        console.log("yes");

        $(".pro-msg").addClass("show");
        $(".error-msg").removeClass("show");
        $(".success-msg").removeClass("show");
        $(".fail-msg").removeClass("show");
        var formdata = new FormData();
        var attachment = document.querySelector("#attachment");
        formdata.append("fullname", self.fullname);
        formdata.append("contactnumber", self.contactnumber);
        formdata.append("email", self.email);
        formdata.append("message", self.message);
        formdata.append("file", attachment.files[0]);
        axios
          .post("./php/work.php", formdata, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            console.log("success", response.data);
            setTimeout(() => {
              $(".success-msg").addClass("show");
              $(".pro-msg").removeClass("show");
            }, 1000);
          })
          .catch(error => {
            console.log(error.response);
            setTimeout(() => {
              $(".pro-msg").removeClass("show");
              $(".fail-msg").addClass("show");
            }, 1000);
          });
      } else {
        console.log("error");
        $(".pro-msg").removeClass("show");
        $(".error-msg").addClass("show");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.pro-msg {
  display: none;
}
.pro-msg.show {
  display: block;
}
.error-msg {
  display: none;
}
.error-msg.show {
  display: block;
}
.success-msg {
  display: none;
}
.success-msg.show {
  display: block;
}
.fail-msg {
  display: none;
}
.fail-msg.show {
  display: block;
}
.btn {
  min-width: 126px;
  font-family: "Avenir";
  background-color: #f1f1f2;
  color: #013d57;
  font-weight: 900;
  padding: 4px 16px;
  font-size: 16px;
  border: none;
  margin-right: 1px;
  cursor: pointer;
}
.btn:hover {
  min-width: 126px;
  font-family: "Avenir";
  background-color: #013d57;
  color: #fff;
  font-weight: 900;
  padding: 4px 16px;
  font-size: 16px;
  border: none;
  margin-right: 1px;
  cursor: pointer;
}
.checkbox {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.checkbox input[type="checkbox"] {
  position: absolute;
  margin: 4px 0 0 0;
  margin-left: -20px;
}
label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bold;
}
.checkbox label {
  min-height: 20px;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: normal;
  cursor: pointer;
}
.form-group {
  height: 75px;
}
.form-group .form-control {
  border-radius: 0;
  border-color: #013d57;
}
.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.form-control:focus {
  border-color: #013d57;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
</style>
